import type { IconProps } from "../../src/types";
import { splitProps } from "solid-js";

function renderSvg(kebab: string, props: IconProps) {
  const [local, rest] = splitProps(props, ["class", "size", "color", "strokeWidth"]);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={local.size ?? 24}
      height={local.size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      stroke={local.color ?? "currentColor"}
      stroke-width={local.strokeWidth ?? 2}
      stroke-linecap="round"
      stroke-linejoin="round"
      class={local.class ? `lucide lucide-${kebab} ${local.class}` : `lucide lucide-${kebab}`}
      aria-hidden={rest["aria-label"] || rest.title ? undefined : "true"}
      {...rest}
    >
      <path d="M3 5h.01" />
      <path d="M3 12h.01" />
      <path d="M3 19h.01" />
      <path d="M8 5h13" />
      <path d="M8 12h13" />
      <path d="M8 19h13" />
    </svg>
  );
}

export const List = (props: IconProps) => renderSvg("list", props);
export const ListIcon = List;
export default List;
